import React from 'react'
import styled from 'styled-components'

import { ChargingSessionType } from '../../common/types/chargingSessionType'
import { ChargingSession } from '../../common/redux/api/web-api'
import { useAdaptConnectorNaming } from '../adaptConnectorNaming'
import isAura from '../isAura'

const Wrapper = styled.div`
    display: flex;
    gap: 4px;
    width: 32px;
`

export type LatestChargingSessionsConnectorInfoProps = {
    chargingSession: ChargingSessionType | ChargingSession
}

export function LatestChargingSessionsConnectorInfo({
    chargingSession,
}: LatestChargingSessionsConnectorInfoProps): React.ReactElement {
    const adaptConnectorNaming = useAdaptConnectorNaming()
    if (chargingSession.productId && chargingSession.productId < 4) {
        if (chargingSession.connectorFunctionType === 'Charger') {
            return <span className="fa fa-car" title={adaptConnectorNaming(chargingSession?.connectorName ?? '')} />
        }

        return (
            <span className="fa icon-socket" title={adaptConnectorNaming(chargingSession?.connectorName ?? '')}></span>
        )
    }
    if (isAura(chargingSession)) {
        if (chargingSession.connectorId === 1) {
            return (
                <Wrapper>
                    <span
                        className="fa fa-circle"
                        title={adaptConnectorNaming(chargingSession?.connectorName ?? '')}
                        data-testid="leftConnector"
                    ></span>
                    <span className="fa fa-circle-o"></span>
                </Wrapper>
            )
        }
        return (
            <Wrapper>
                <span className="fa fa-circle-o"></span>
                <span
                    className="fa fa-circle"
                    title={adaptConnectorNaming(chargingSession?.connectorName ?? '')}
                    data-testid="rightConnector"
                ></span>
            </Wrapper>
        )
    }

    if (chargingSession.productId === 7) {
        return <span className="fa fa-car" title={adaptConnectorNaming(chargingSession?.connectorName ?? '')} />
    }

    return <div data-testid="emptyDiv"></div>
}
